import Axios from './index'
let context = process.env.VUE_APP_BASEURL
export default {
   //详情信息
   getDetailInfo(data) {
      return Axios.post(context + '/india/eventbooking/events/GetEventRegistrationDetail', data)
   },
   //验证recaptcha v3
   checkAccsstoken(data){
      return Axios.post(context + '/master/openService/v3/validate', data)
   },
   //校验ABO
   ValidateTrain(data) {
      return Axios.post(context + '/india/eventbooking/ticket/ValidateEventAttendee', data)
   },
   //sign in签到 --- /校验ABO和token
   RegisterTrain(data) {
      return Axios.post(context + '/india/eventbooking/ticket/RegisterEventAttendee', data)
   },
   //get ABO party List
   GetAboPartyList(data) {
      return Axios.post(context + '/india/eventbooking/ticket/GetAboPartyList', data)
   }
   ,
   // validate ABO phone number
   ValidatePhoneNumber(data) {
      return Axios.post(context + '/india/eventbooking/ticket/CheckPhoneNumber', data)
   },
      //validate ABO number
   ValidateAboNumber(data) {
      return Axios.post(context + '/india/eventbooking/ticket/CheckAboNumber', data)
   },
   //sign in签到 --- /校验ABO和token
   NewRegisterTrain(data) {
      return Axios.post(context + '/india/eventbooking/ticket/NewRegisterEventAttendee', data)
   }
}